import { computed } from 'vue'
import { useStore } from 'vuex'
import { roleSectionTitle } from '@/components/notifications/notificationLogic.mjs'

export function useNotificationUser() {
  const store = useStore()
  const user = computed(() => store.state.user?.user || {})
  const userRoleId = computed(() => {
    const raw = user.value?.role_id ?? user.value?.role?.id
    if (raw == null || raw === '') return NaN
    const n = Number(raw)
    return Number.isFinite(n) ? n : NaN
  })
  const isAuthenticated = computed(() => {
    return Number.isFinite(userRoleId.value) && userRoleId.value !== 99 && !!user.value?.id
  })
  const roleTitle = computed(() => roleSectionTitle(user.value?.role?.name))

  return { user, userRoleId, isAuthenticated, roleTitle }
}
